import {useCallback, useEffect, useRef} from 'react';
import {showSecondLayer} from '@s-group/react-usercentrics';

const VIEW_CHANGED_EVENT = 'UC_UI_VIEW_CHANGED';
const NO_LAYER_OPEN = 'NONE';

const useConsentLayerTrigger = <TriggerElement extends HTMLElement = HTMLElement>() => {
    const triggerRef = useRef<TriggerElement>(null);
    const isAwaitingCloseRef = useRef(false);

    useEffect(() => {
        const handleViewChanged = (event: Event) => {
            const {view} = (event as CustomEvent<{view?: string}>).detail ?? {};
            if (view !== NO_LAYER_OPEN || !isAwaitingCloseRef.current) return;

            isAwaitingCloseRef.current = false;

            const triggerElement = triggerRef.current;
            if (triggerElement?.isConnected) {
                triggerElement.focus();
            }
        };

        window.addEventListener(VIEW_CHANGED_EVENT, handleViewChanged);
        return () => window.removeEventListener(VIEW_CHANGED_EVENT, handleViewChanged);
    }, []);

    const openConsentLayer = useCallback(() => {
        isAwaitingCloseRef.current = true;
        showSecondLayer();
    }, []);

    return {openConsentLayer, triggerRef};
};

export default useConsentLayerTrigger;
